import { createInboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/InboxMessageHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const readMessageUseCase = async (id: string, tokenProvider: TokenProvider) => {
  const repository = createInboxMessageHttpRepository(tokenProvider);
  return await repository.readMessage(id);
};
